export default __webpack_public_path__ + "static/media/Selected_Jump_Spin.246ee94e.svg";